<template>
  <div id="app">
    <!-- 路由出口：所有页面都在这里渲染 -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 全局基础样式，统一所有页面的基础外观 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif;
  background-color: #f5f5f5;
  color: #333;
}

/* 全局容器样式（所有页面共用） */
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

/* 全局卡片样式（统一所有卡片外观） */
.base-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 20px;
}

/* 全局按钮hover效果统一 */
.el-button:hover {
  opacity: 0.9;
}

/* 全局链接样式 */
a {
  text-decoration: none;
}

/* 清除浮动 */
.clearfix::after {
  content: "";
  display: block;
  clear: both;
}
</style>
